import { render, staticRenderFns } from "./InstallSale.vue?vue&type=template&id=2ff284ca&scoped=true&"
import script from "./InstallSale.vue?vue&type=script&lang=js&"
export * from "./InstallSale.vue?vue&type=script&lang=js&"
import style0 from "./InstallSale.vue?vue&type=style&index=0&id=2ff284ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff284ca",
  null
  
)

export default component.exports